import React, { useMemo, useEffect, useState } from "react";
import { useTable, usePagination } from "react-table";
import { MYSOLDVEHICLECOLUMNS } from "./Column";
import { useAuth } from "../../store/Auth";
import Swal from "sweetalert2";
import EmptyList from "../../components/empty-list-2.webp";
import { base, my_sold_vehicles } from "../../constants/urls";
import { ClipLoader } from "react-spinners";
import { Link } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import Header from "../assist/Title";

export default function MySoldVehiclesTable() {
  const [result, setResult] = useState([]);
  const columns = useMemo(() => MYSOLDVEHICLECOLUMNS, []);
  const data = useMemo(() => result, [result]);
  const getAuth = useAuth((state) => state.auth);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let token = getAuth.token;
    let url = base + my_sold_vehicles;
    const fetchRequest = async () => {
      setLoading(true);
      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          return response.json();
          console.log(data);
        })
        .then(({ data }) => {
          Array.isArray(data) ? setResult(data) : setResult([]);

          setLoading(false);
        })
        .catch((err) => {
          let message;

          if (err && err.response) {
            const { data } = err.response;
            message = data.message;
          }

          Swal.fire(message || "Unable to fetch request");
          setLoading(false);
        });
    };
    fetchRequest();
  }, []);

  result.forEach((results, index) => {
    results.serial = index + 1;
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    canNextPage,
    setPageSize,
    gotoPage,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
    },
    usePagination
  );
  return (
    <div className="bg-gray-100">
      <Header />
      <div className="mt-8 px-4 lg:px-16 bg-gray-100 shadow-xs">
        <div className="flex">
          {/* <div className="flex-1 text-xl mt-2 font-semibold">
            My Sold Vehicles
          </div> */}
          <div className="flex-1 justify-end">
            <Link
              to="/requests"
              className="cursor-pointer font-semibold text-sky-400 hover:text-sky-600 text-md mt-2 flex justify-end"
            >
              <AiOutlineClose className="mr-1 mt-1" />
              Back to Requests
            </Link>
          </div>
        </div>
        <div className="py-3">
          <div className="mt-2 text-gray-500 space-y-5 overflow-x-scroll">
            <table
              {...getTableProps()}
              className="w-full border overflow-x-scroll"
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    className="text-gray-600"
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps()}
                        className="py-2 px-2 text-md font-semibold text-left bg-blue-100"
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              {loading ? (
                <tbody className="my-20 text-center">
                  <tr>
                    <td colSpan={headerGroups[0].headers.length}>
                      <ClipLoader
                        color={"#166434"}
                        size={30}
                        aria-label="Loading Spinner"
                      />
                      <p className="mt-2 text-gray-500">Loading...</p>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <>
                  {result.length === 0 ? (
                    <tbody>
                      <tr>
                        <td colSpan={headerGroups[0].headers.length}>
                          <p className="flex items-center justify-center flex-col">
                            <span className="text-center text-gray-500 my-8">
                              You do not have any Approved Request
                            </span>
                            <span className="py-4">
                              <img alt="empty" src={EmptyList} />
                            </span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody {...getTableBodyProps()} className="">
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr
                            {...row.getRowProps()}
                            className="even:bg-blue-100"
                          >
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  className="py-4 px-2 font-normal text-md"
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  )}
                </>
              )}
            </table>
            <div className="flex justify-center sm:justify-between items-center flex-wrap">
              <div className="mb-2">
                <span>
                  Go to page:{" "}
                  <input
                    type="number"
                    defaultValue={pageIndex + 1}
                    onChange={(e) => {
                      const pageNumber = e.target.value
                        ? Number(e.target.value) - 1
                        : 0;
                      gotoPage(pageNumber);
                    }}
                    className="md:w-32 w-12 border border-gray-200 rounded mr-4  px-4 py-1"
                  />
                </span>
              </div>
              <div className="mb-2 flex justify-between items-center space-x-1">
                <button
                  className="disabled:bg-gray-100 disabled:text-gray-400 px-2 py-1 md:px-4 md:py-2 inline-flex items-center text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700"
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                >
                  Prev
                </button>
                <span className="">
                  {pageIndex + 1} / {pageOptions.length}
                </span>

                <button
                  className="disabled:bg-gray-50 disabled:text-gray-400 inline-flex items-center px-2 py-1 md:px-4 md:py-2 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700"
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                >
                  Next
                </button>
              </div>
              <div className="text-center mb-2">
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                  className="w-32 border border-gray-200 rounded mr-4  px-4 py-1"
                >
                  {[10, 25, 50, 100].map((pageSize) => (
                    <option value={pageSize} key={pageSize}>
                      Show {pageSize}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
